
































































  import { mapGetters, mapActions } from 'vuex'
  import { Component, Prop, Vue, Emit } from 'vue-property-decorator'
  import SkillItemComponent from './SkillItemComponent.vue'
  import Skill from '../models/Skill'
  import { State, Getter, Action, Mutation } from '../store-helper'
  import Question from '../models/Question';
  import { qEditorState } from '../stores'

  @Component({
    components: {
      SkillItemComponent
    }
  })
  export default class SkillComponent extends Vue {
    @Prop()
    skill: Skill

    public newSkillItemName: string = ""
    public isOpen: boolean = false
    public skillName: string = ""
    public editSkill: boolean = false
    public removeSkillModal: boolean = false

    public toggle() {
      this.isOpen = !this.isOpen;
    }

    public runAddSkillItem() {
      if(!this.newSkillItemName) return;

      qEditorState.addSkillItem({ skill: this.skill, params: { name: this.newSkillItemName } })
      this.newSkillItemName = ""
      this.isOpen = false
    }

    public editSkillToogle(){
      this.skillName = this.skill.name
      this.editSkill = !this.editSkill
    }

    public changeSkillName(){
      qEditorState.updateSkill({skill: this.skill, params: { name: this.skillName }})
      this.editSkillToogle()
    }

    public runRemoveSkill(){
      qEditorState.removeSkill({skill: this.skill})
      this.removeSkillModal = false
    }
  }
